import React, { memo, useState } from 'react';
import { ProductImage } from './components/ProductImage';
import { ProductContent } from './components/ProductContent';
import { ProductCardHome as ProductCardHomePropTypes } from 'core/propTypes/propTypes';
import 'assets/css/product-card.css';

const ProductCardHome = ({ item, publicUrl, onQuickView, loading, redirect }) => {
  const [selectedOptionIndex, setSelectedOptionIndex] = useState(0);
  const selectedOption = item.product_option[selectedOptionIndex];

  return (
    <div className="col-lg-12 col-md-12 m-auto col-12 d-flex justify-content-center">
      <div className="product-card ltn__product-item ltn__product-item-4 text-center--">
        <ProductImage
          images={selectedOption?.url ? [selectedOption.url] : item.photos.map(photo => photo.src)}
          badge={item.category_name || item?.category[0]?.title}
          sliderRef={null}
          onQuickView={() => onQuickView(item)}
          id={redirect ? item.product_id : item.id}
          loading={loading}
          appliedPhotos={item.applied_photos}
        />
        <ProductContent
          item={item}
          selectedOption={selectedOption}
          onOptionClick={setSelectedOptionIndex}
          optionsRef={null}
          id={redirect ? item.product_id : item.id}
        />
      </div>
    </div>
  );
};

ProductCardHome.propTypes = ProductCardHomePropTypes;

export default memo(ProductCardHome);